/*
* 批量指令历史一览
* 创建时间：2017-07-12
* 创建人：baixx
*/
<template>
	<div class="wrapper-content fadeInRight animated tabBox" id="bat-directiveList">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		    <!--表单部分开始-->
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">指令下发开始时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
						<datepicker class="form-control" v-model="queryParam.sendTimeStart" ref="dateFrom"></datepicker>
						<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
					<label class="col-sm-1 control-label">指令下发结束时间</label>
					<div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
						<datepicker class="form-control" v-model="queryParam.sendTimeEnd" ref="dateTo"></datepicker>
						<p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
					</div>
					<label class="col-sm-1 control-label ">下发人</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.userId">
							<option v-for="(option, index) in suedlist" v-bind:value="option.userId" :key="'suedlist' + index">
								{{ option.userName }}
							</option>
						</select>
					</div>
					<label class="col-sm-1 control-label">指令名称</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model="queryParam.cmdName">
					</div>
				</div>

				<div class="form-group">
					<div class="col-sm-12 text-right">
						<button  class="btn btn-primary" @click="resetQueryParams">重置</button>
						<button  class="btn btn-primary" @click="searchInfo" :disabled="!validDates">查询</button>
					</div>
				</div>
			</div>
			<!--表单部分结束-->
			<!--列表部分开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr role="row">
							<th>指令下发时间</th>
							<th>指令名称</th>
							<th>指令类型</th>
							<th>指令下发人</th>
							<th>涉及设备数</th>
							<th>成功发送数</th>
							<th>处理失败数</th>
						</tr>
					</thead>
					<transition-group name="list-complete" tag="tbody">
						<tr v-for="(info,index) in infoList" v-bind:key="index + 'batdire'" class="list-complete-item">
						    <td>{{info.sendTime}}</td>
							<td>{{info.cmdName}}</td>
							<td>{{info.cmdTypeName}}</td>
							<td>{{info.userName}}</td>
							<td>{{info.deviceCount}}&nbsp;&nbsp;&nbsp;<a v-show="info.deviceCount!=0"  @click="exportDocument(info.id,0)">导出</a></td>
							<td>{{info.successCount}}&nbsp;&nbsp;&nbsp;<a v-show="info.successCount!=0"  @click="exportDocument(info.id,1)">导出</a></td>
							<td>{{info.failureCount}}&nbsp;&nbsp;&nbsp;<a v-show="info.failureCount!=0"  @click="exportDocument(info.id,2)">导出</a></td>
						</tr>
					</transition-group>

				</table>
			</div>
			<!--列表部分结束-->
			<!--分页组件开始-->
			<pagination
				v-if="infoList.length>0"
				:pageInfo="pageInfo"
				v-on:getData="getPageNo"
				>
			</pagination>
			<!--分页组件结束-->
			 	<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
		</div>
	</div>
</template>
<script>
	import Pagination from 'components/common/Pagination'
	import Datepicker from 'components/common/datepicker/Datepicker'
	import { OPERATE_EXCEPTION } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'

	export default {
	  name: 'PageBatDirectiveHistoryList',
	  components: {
	    Pagination,
	    Datepicker,
	    TabModal
	  },
	  data () {
	    return {
	      loadingstatus: false,
	      infoList: [],						                          // 从接口获取的表格数据
	      suedlist: [],                                                // 指令人列表
	      pageInfo: {},						                          // 传给分页组件的属性对象
	      messageStr: '',					                              // 弹出框内容
	      scrollTop: '0',
				// 以下为查询属性
	      queryParam: {
	        cmdName: '',					                              // 指令名称
	        customerId: this.$store.state.user.groupid,				  // 当前用户所属机构
	        sendTimeStart: '',			                              // 指令时间下发起
	        sendTimeEnd: '',				                              // 指令时间下发止
	        userId: '',					                              // 指令发出人
	        page_index: 1
	      }
	    }
	  },
	  beforeMount () {
	    this.getTableInfo()
	    this.getIssuedList()
	  },
	  computed: {
			//	起止时间是否合法
	    validDates: function () {
	      if (this.queryParam.sendTimeStart && this.queryParam.sendTimeEnd && this.queryParam.sendTimeStart > this.queryParam.sendTimeEnd) {
	        return false
	      } else {
	        return true
	      }
	    }
	  },
	  methods: {
			// 查询方法
	    searchInfo () {
	      this.queryParam.page_index = 1
	      this.getTableInfo()
	    },
			// 获取历史指令批量信息信息
	    getTableInfo () {
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/bat-command', {params: this.queryParam})
					.then((response) => {
	  console.log(response)
	  if (response.body.success) {
	    const resInfo = response.body.data
	    const {pageNum, pages, total, isFirstPage, isLastPage} = resInfo
	    this.pageInfo = {
	      pageNum: pageNum,
	      pages: pages,
	      total: total,
	      isFirstPage: isFirstPage,
	      isLastPage: isLastPage
	    }
	    this.infoList = resInfo.list
	  } else {
	    this.openModalMsg(response.body.message)
	  }
	  this.loadingstatus = false
	}, (response) => {
	  this.openModalMsg(response.body.message)
	  this.loadingstatus = false
	})
					.catch((response) => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
	    },
			// 获取下发人列表
	    getIssuedList () {
	      this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/bat-command/users', {params: {customerId: this.$store.state.user.groupid}})
				.then(res => {
	  if (res.body.success) {
					 	this.suedlist = res.body.data
	  } else {
	    this.openModalMsg(res.data.message)
	  }
	}, res => {
	  this.openModalMsg(res.data.message)
	}).catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	})
	    },
			// 导出
	    exportDocument (batId, type) {
	      const para = {
	        batId: batId,			   // 批处理ID
	        type: type			       // 下载范围
			    }
	      this.$http.get(process.env.API_ROOT + '/vehicle/vehicles/devices/bat-command/download', {params: para})
					.then((res) => {
	  if (res.body.success) {
	    let str = res.body.data
	    var path = process.env.EXPORT_PATH
				    var api = process.env.API_ROOT
	    var fileName = path + api + '/noauth/export?url=' + str
	    			var elemIF = document.createElement('iframe')
			      	elemIF.src = fileName
			        elemIF.style.display = 'none'
			        document.body.appendChild(elemIF)
	  } else {
	    this.openModalMsg(res.data.message)
	  }
	}, res => {
	  this.openModalMsg(res.data.message)
	}).catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	})
	    },
	    getPageNo (pageNo) { // 从分页组件获取页码参数
	      this.queryParam.page_index = pageNo
	      this.getTableInfo()
	    },
			// 消息弹出框相关
	    openModal (ref) {
            	this.$refs[ref].open()
            	classlist.toggleScroll('close', '#bat-directiveList', this)
        	},
        	closeModal (ref) {
        		this.$refs[ref].close()
        		 classlist.toggleScroll('open', '#bat-directiveList', this)
        	},
        	closeModalMsg () {
        		this.closeModal('modalMsg')
        	},
        	openModalMsg (message) {
        		this.messageStr = message
        		this.openModal('modalMsg')
        	},
	    resetQueryParams: function () {
	      this.$refs.dateFrom.handleClear()
	      this.$refs.dateTo.handleClear()
	      this.queryParam = {
	        cmdName: '',					                          // 指令名称
	        customerId: this.$store.state.user.groupid,			  // 当前用户所属机构
	        sendTimeStart: '',			                          // 指令时间下发起
	        sendTimeEnd: '',				                          // 指令时间下发止
	        userId: ''	                                          // 指令发出人
	      }
	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// PageBatDirectiveHistoryList.vue?e5f14db8